"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorProvider = void 0;
const React = __importStar(require("react"));
const apolloCache_1 = require("../apolloCache");
const client_1 = require("@apollo/client");
exports.ErrorProvider = ({ graphQLErrors, children, }) => {
    const link = new client_1.ApolloLink(() => {
        return new client_1.Observable(observer => {
            observer.next({
                errors: graphQLErrors || [
                    { message: "Unspecified error from ErrorProvider." },
                ],
            });
            observer.complete();
        });
    });
    const client = new client_1.ApolloClient({
        link,
        cache: apolloCache_1.apolloCache,
    });
    return React.createElement(client_1.ApolloProvider, { client: client }, children);
};
//# sourceMappingURL=ErrorProvider.js.map